import {
  itemKindFromState,
  customInformationByRouteParam,
} from './custom-information.selectors';
import { STATES } from '../../../constants';
import { actions } from '../../../state';

export function CustomInformationConfig($stateProvider) {
  'ngInject';
  let stateConfig = {};

  $stateProvider.state(STATES.STEP_CUSTOM_INFORMATION, {
    url: '/info/:code',
    views: {
      '@': {
        template: '<upd-custom-information></upd-custom-information>',
      },
    },
    scrollTop: true,
    resolve: {
      itemDefinition: ($stateParams, updStore) => {
        const state = updStore.getState();
        const itemDefinition = customInformationByRouteParam($stateParams.code);
        return {
          code: itemDefinition.code(state),
          icon: itemDefinition.icon(state),
          page: itemDefinition.page(state) || {},
        };
      },
      guard: (itemDefinition, updStore) => {
        if (!itemDefinition.code) {
          updStore.dispatch(actions.router.stateGo(STATES.DASHBOARD));
        }
      },
    },
    title: () => stateConfig.breadcrumb_title,
    titleBar: {
      title: () => stateConfig.title,
      icon: () => stateConfig.icon,
    },
    data: {
      moveItem: {
        type: itemKindFromState,
        singleton: true,
      },
    },
    analytics: {
      ignore: true,
    },
    onEnter: itemDefinition => {
      'ngInject';
      stateConfig = {
        ...itemDefinition.page,
        icon: itemDefinition.icon,
      };
    },
  });
}
